// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0;
  margin: 0;
  z-index: 9999;
  list-style: none;
  min-width: 85px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_contextMenu.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yCAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AACF","sourcesContent":[".context-menu {\n  position: fixed;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  padding: 0;\n  margin: 0;\n  z-index: 9999;\n  list-style: none;\n  min-width: 85px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
